module.exports = __webpack_public_path__ + "img/MOBILE-WIDE_PORTA-UN-AMICO_622x176.dfe8396e.jpg";